import price1 from './../img/slider/family/family_21.webp';
import price2 from './../img/slider/family/family_5.webp';
import price3 from './../img/slider/portrait/portrait_45.webp';
import price4 from './../img/slider/family/family_3.webp';
import price5 from './../img/slider/events/events_23.webp';
import price6 from './../img/slider/business/business_22.webp';

const priceImages = [price1, price2, price3, price4, price5, price6];

export { priceImages };
